import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import styled from 'styled-components';
import moment from 'moment';
import 'moment/locale/es';
import {getEventsById} from "../../endpoints"
import {
  DivContainer,
  ModalOverlay,
  ModalContent,
  CloseButton,
  EventForm,
  ButtonContainer
} from "./styles"
moment.locale('es');

const localizer = momentLocalizer(moment);

const MyCalendar = ({user}) => {
  const [events, setEvents] = useState([])
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [newEvent, setNewEvent] = useState({ title: '', start: null, end: null });


  const getEventsUser = async () => {
    getEventsById(user.id).then((res) =>{
      if(res.status === 200){
        const eventos = res.data.eventos.map(evento => ({
          id: evento.id,
          title: evento.nombreDelEvento, // Nombre del evento en el nuevo formato
          start: new Date(evento.fechaDelEvento), // Fecha del evento en el nuevo formato
          end: new Date(evento.fechaDelEvento), // Fecha del evento en el nuevo formato
          detalle: evento.detalle,
          objetoRelacionado:evento.objetoRelacionado // Detalle del evento en el nuevo formato
          // Añade más propiedades si las necesitas
        }));
        setEvents(eventos);
      }else {
        console.log(res)
      }
    })
  }

  useEffect(()=> {
    getEventsUser()
  },[user])



  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedEvent(null);
  };

  const handleSelect = ({ start, end }) => {
    setNewEvent({ title: '', start, end });
    openModal();
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    openModal();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewEvent(prevEvent => ({
      ...prevEvent,
      [name]: value
    }));
  };

  const handleModalSubmit = () => {
    if (newEvent.title && newEvent.start && newEvent.end) {
      if (selectedEvent) {
        const updatedEvents = events.map(ev => ev.id === selectedEvent.id ? { ...newEvent, id: ev.id } : ev);
        setEvents(updatedEvents);
      } else {
        setEvents([...events, { ...newEvent, id: events.length + 1 }]);
      }
      setModalIsOpen(false);
    } else {
      alert('Por favor, complete todos los campos.');
    }
  };

  const handleEventDelete = () => {
    setEvents(events.filter(ev => ev.id !== selectedEvent.id));
    setModalIsOpen(false);
  };

  return (
    <DivContainer>
      <StyledCalendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        onSelectSlot={handleSelect}
        onSelectEvent={handleEventClick}
        selectable
        resizable
        formats={{
          dateFormat: 'DD/MM/YYYY',
        }}
        messages={{
          today: 'Hoy',
          previous: 'Anterior',
          next: 'Siguiente',
          month: 'Mes',
          week: 'Semana',
          day: 'Día',
          showMore: total => `+ Mostrar más (${total})`
        }}
      />
      {modalIsOpen && (
        <ModalOverlay>
          <ModalContent>
            <CloseButton onClick={closeModal}>X</CloseButton>
            {selectedEvent ? (
              <>
                <h2>{selectedEvent.title}</h2>
                <p>fecha: {moment(selectedEvent.end).format('YYYY-MM-DD HH:mm')}</p>
                <p>contacto relacionado: 
                  <a href={`https://crmmerci.testeoenzo.online/contacts/${selectedEvent.objetoRelacionado}`}
                  target='_blank' 
                  >LINK</a>
                  </p>
                <p>detalle: {selectedEvent.detalle}</p>
    
              </>
            ) : (
              <EventForm>
                <h2>{newEvent.id ? 'Editar Evento' : 'Agregar Evento'}</h2>
                <label>Título:</label>
                <input type="text" name="title" value={newEvent.title} onChange={handleInputChange} />
                <label>Inicio:</label>
                <input type="datetime-local" name="start" value={newEvent.start ? moment(newEvent.start).format('YYYY-MM-DDTHH:mm') : ''} onChange={handleInputChange} />
                <label>Fin:</label>
                <input type="datetime-local" name="end" value={newEvent.end ? moment(newEvent.end).format('YYYY-MM-DDTHH:mm') : ''} onChange={handleInputChange} />
                <ButtonContainer>
                  <button type="button" onClick={handleModalSubmit}>{newEvent.id ? 'Guardar' : 'Agregar'}</button>
                  <button type="button" onClick={closeModal}>Cancelar</button>
                </ButtonContainer>
              </EventForm>
            )}
          </ModalContent>
        </ModalOverlay>
      )}
    </DivContainer>
  );
};

export default MyCalendar;

const StyledCalendar = styled(Calendar)`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  min-width: 100%;
`;